import getStore from '../store';
import { mutator } from 'satcheljs';
import { setSearchTerms } from '../actions/searchResultStoreActions';

/**
 * Sets the search terms value.
 */
export let setSearchTermsMutator = mutator(setSearchTerms, query => {
    let store = getStore();
    store.searchTerms = query.searchTerms;
});
